import React from 'react';
import { MapPin } from 'lucide-react';
import { IMG } from '../mock/mock';
import { LeafTopLeft, LeafTopRight, LeafBottomLeft, LeafBottomRight } from './Leaves';

export default function Hero() {
  return (
    <section className="relative -mt-[112px] min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={IMG.hero}
          alt="Eco-Lak vízparti készház"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65" />
      </div>

      {/* Leaf decorations - corners */}
      <LeafTopLeft className="absolute top-0 left-0 w-44 md:w-60 h-auto pointer-events-none z-[5]" />
      <LeafTopRight className="absolute top-0 right-0 w-44 md:w-60 h-auto pointer-events-none z-[5]" />
      <LeafBottomLeft className="absolute bottom-0 left-0 w-40 md:w-56 h-auto pointer-events-none z-[5]" />
      <LeafBottomRight className="absolute bottom-0 right-0 w-40 md:w-56 h-auto pointer-events-none z-[5]" />

      {/* Content card */}
      <div className="relative z-10 max-w-3xl mx-auto px-6 pt-28 pb-20">
        <div className="backdrop-blur-md bg-black/35 border border-white/10 rounded-2xl px-8 md:px-14 py-12 md:py-16 text-center fade-up">
          <div className="flex justify-center mb-6">
            <img src={IMG.logo} alt="Eco-Lak" className="w-24 h-24 md:w-28 md:h-28 object-contain drop-shadow-lg" />
          </div>

          <div className="flex justify-center mb-3">
            <div className="w-12 h-px bg-[#2BA8C0]" />
          </div>

          <p className="text-white/85 text-[12px] md:text-[13px] uppercase tracking-[0.35em] mb-7">
            Eco-Lak Készházak
          </p>

          <h1 className="font-serif-display text-white text-5xl md:text-[68px] leading-[1.05] mb-7">
            Otthon a Velencei-tó <br className="hidden md:block" />környékén.
          </h1>

          <p className="text-white/80 text-[15px] md:text-base leading-relaxed max-w-xl mx-auto mb-7">
            Könnyűszerkezetes házak tervezése és kivitelezése.<br />
            Fenntartható megoldások, modern élettér.<br />
            Célunk a zöld építészet jövője.
          </p>

          <div className="flex items-center justify-center gap-2 text-white/85 text-[14px] mb-9">
            <MapPin className="w-4 h-4 text-[#2BA8C0]" />
            <span>Velencei-tó, Fejér megye</span>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#keszhazak"
              className="px-7 py-3.5 rounded-md bg-[#2BA8C0] text-white text-[14px] font-medium hover:bg-[#239ab1] transition-colors shadow-md"
            >
              Fedezze fel otthonait
            </a>
            <a
              href="#kapcsolat"
              className="px-7 py-3.5 rounded-md border border-white/40 text-white text-[14px] font-medium hover:bg-white/10 transition-colors"
            >
              Ingyenes konzultáció
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
